import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  TextField,
  Button,
  Box,
} from "@mui/material";

const INITIAL_VALUES = {
  value: "",
  name: "",
};

export default function SizeFormDialog({ open, onClose, onSave, rowId, size }) {
  const [data, setData] = useState(INITIAL_VALUES);

  useEffect(() => {
    if (!open) return;

    if (rowId && size) {
      setData({
        value: String(size.value ?? ""),
        name: size.name || "",
      });
    } else {
      setData(INITIAL_VALUES);
    }
  }, [rowId, size, open]);

  const handleClose = () => {
    setData(INITIAL_VALUES);
    onClose();
  };

  const valueNum = Number(data.value);
  const isValid =
    data.name.trim() !== "" &&
    data.value !== "" &&
    !Number.isNaN(valueNum) &&
    Number.isInteger(valueNum) &&
    valueNum >= 0;

  const handleSave = () => {
    onSave({
      value: valueNum,
      name: data.name.trim(),
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{rowId ? "Edit Size" : "Create Size"}</DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ mb: 3 }}>
          {rowId
            ? "Update the size value and name."
            : "Enter value (e.g. 750) and name (e.g. 750ml) to create a new size."}
        </DialogContentText>

        <Box
          autoComplete="off"
          sx={{ display: "flex", flexDirection: "column", gap: 3 }}
        >
          <TextField
            label="Value"
            type="number"
            fullWidth
            required
            autoComplete="off"
            value={data.value}
            onChange={(e) => setData({ ...data, value: e.target.value })}
            slotProps={{
              htmlInput: { min: 0, step: 1 },
            }}
            helperText="Non-negative integer (e.g. 750)"
          />

          <TextField
            label="Name"
            fullWidth
            required
            autoComplete="off"
            value={data.name}
            onChange={(e) => setData({ ...data, name: e.target.value })}
            helperText="e.g. 750ml, bottle, case"
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={!isValid}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
